import PanelBoxLayout from 'components/layout/panelBox';
// import PaginationApp from "components/pagination";

import * as T from 'common/types';
import * as S from './styles';
import DangerButton from 'components/form/buttons/danger';
import Gap from 'components/gap';
// import RateStar from "components/rateStar";
import { useActions } from 'common/hooks/useActions';
import QuestionModal from 'components/modal/question';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import PrimaryButton from 'components/form/buttons/primaryButton';
import ModalApp from 'components/modalApp';
import ChangeDateTimeForm from '../changeTimeForm';

interface IProps {
  data: T.Pages.ReservationDetail;
  fetchData: () => void;
}

export default function ReservationDetailInfo({ data, fetchData }: IProps) {
  const { reservationCancelRequestAction } = useActions();
  const [showCloseModal, setShowCloseModal] = useState<boolean>(false);
  const [showTimeModal, setShowTimeModal] = useState<boolean>(false);

  const navigate = useNavigate();

  const handleShowCloseTicket = () => {
    setShowCloseModal(true);
  };

  const handleHideCancel = () => {
    setShowCloseModal(false);
  };

  const handleShowTimeModal = () => {
    setShowTimeModal(true);
  };

  const handleCloseTimeModal = () => {
    setShowTimeModal(false);
  };

  const handleCancelReservation = () => {
    reservationCancelRequestAction(data.id, () => {
      handleHideCancel();
      navigate('/panel/reservation');
    });
  };

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <S.Content>
      <PanelBoxLayout style={{ padding: '20px 30px' }}>
        <S.Head>Reservation Details</S.Head>
        <Gap size="10px" />
        <S.Div className="row">
          <S.Div className="col-6">
            <S.Item>
              <S.Title>Room</S.Title>
              <S.Text>{data?.room?.name}</S.Text>
            </S.Item>
          </S.Div>
          <S.Div className="col-6">
            <S.Item>
              <S.Title>Time</S.Title>
              <S.Text>{`${data?.start_time} - ${data?.end_time}`}</S.Text>
            </S.Item>
          </S.Div>
          <S.Div className="col-md-6">
            <S.Item>
              <S.Title>Start Date</S.Title>
              <S.Text>{data?.startDate ? formatDate(data?.startDate) : ''}</S.Text>
            </S.Item>
          </S.Div>
          <S.Div className="col-md-6">
            <S.Item>
              <S.Title>End Date</S.Title>
              <S.Text>{data?.endDate ? formatDate(data?.endDate) : ''}</S.Text>
            </S.Item>
          </S.Div>
        </S.Div>
        <Gap size="20px" />
        <S.Head>People</S.Head>
        <Gap size="25px" />
        <S.PeopleContainer>
          {data?.people?.map((item) => (
            <S.Div className="w-full">
              <S.UserCard>
                <S.Grid>
                  <S.Icon src={item?.profilePicture || '/images/default-avatar.jpg'} />
                  <S.Div className="full">
                    <S.MainTitle>
                      {item.name?.length > 15 ? `${item.name?.substring(0, 15)}...` : item.name}
                      <S.Span>
                        {item.jobTitle?.length > 15 ? `${item.jobTitle?.substring(0, 15)}...` : item.jobTitle}
                      </S.Span>
                    </S.MainTitle>
                    <S.Text style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                      {item.mail?.length > 25 ? `${item.mail?.substring(0, 25)}...` : item.mail}
                      <span>{item.label}</span>
                    </S.Text>
                  </S.Div>
                </S.Grid>
              </S.UserCard>
            </S.Div>
          ))}
        </S.PeopleContainer>
        <Gap size="20px" />

        <S.GridButton>
          <PrimaryButton
            style={{
              background: '#DFE0EB66',
              color: '#0A2142',
              fontSize: 14,
              fontWeight: 400,
              borderRadius: 8,
              height: 36
            }}
            onClick={handleShowTimeModal}
            disabled={data?.status === 'canceled' ? true : false}
          >
            Change Date and Time
          </PrimaryButton>
          <DangerButton
            style={{
              background: '#FDF0EF',
              fontSize: 14,
              fontWeight: 400,
              borderRadius: 8,
              height: 36,
              width: 208
            }}
            onClick={handleShowCloseTicket}
            disabled={data?.status === 'canceled' ? true : false}
          >
            Cancel Reservation
          </DangerButton>
        </S.GridButton>
      </PanelBoxLayout>

      <QuestionModal
        show={showCloseModal}
        handleClose={handleHideCancel}
        model="delete"
        title="Cancel Reservation"
        text="Do you want to Cancel this Reservation?"
        handleSuccess={handleCancelReservation}
        successButtonText="Yes"
      />

      <ModalApp show={showTimeModal} handleClose={handleCloseTimeModal} fixed style={{ width: 520 }}>
        <ChangeDateTimeForm data={data} handleClose={handleCloseTimeModal} fetchData={() => fetchData()} />
      </ModalApp>
    </S.Content>
  );
}
